export default __webpack_public_path__ + "static/media/beetrootpowder.06c40605.jpg";